export default {
    setUser (context, value) {
        context.commit('SET_USER', value)
    },
    setAuction (context, value) {
        context.commit('SET_AUCTION', value)
    },
    setLot (context, value) {
        context.commit('SET_LOT', value)
    },
    setLots (context, value) {
        context.commit('SET_LOTS', value)
    },
    setSelectedLot (context, value) {
        context.commit('SET_SELECTED_LOT', value)
    },
    setBidders (context, value) {
        context.commit('SET_BIDDERS', value)
    },
    loadUser (context, value) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/live2/user`)
                .then(response => {
                    context.commit('SET_USER', response.data.data)
                    resolve(response.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    loadAuction (context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/live2/auction/${id}`)
                .then(response => {
                    context.commit('SET_AUCTION', response.data.data)
                    resolve(response.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    loadLots (context, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/live2/auction/${id}/lots`)
                .then(response => {
                    context.commit('SET_LOTS', response.data.data)
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    loadLot (context, id) {
        return new Promise((resolve, reject) => {
            context.commit('RESET_BIDS')
            context.commit('RESET_WINNER')
            axios.get(`/api/live2/auction/${id}/current`)
                .then(response => {
                    context.commit('SET_LOT', response.data.data)
                    context.commit('SET_CURRENT_LOT', response.data.data)
                    context.dispatch('openTimer');
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    receiveUpdateAuctionStatus (context, payload) {
        context.commit('SET_AUCTION', payload)
    },
    receiveStreamChanged (context, payload) {
        context.commit('SET_STREAM', payload.cs)
    },
    sendBid(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/live2/auction/${payload.auction_id}/bid`, {
                    lot_id: payload.lot_id,
                    amount: payload.amount
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    sendAmount(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/live2/auction/${payload.auction_id}/more`, {
                    lot_id: payload.lot_id,
                    amount: payload.amount
                })
                .then(response => {
                    context.commit('SET_LOT', response.data.data)
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    recallLot(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/live2/auction/${payload.auction_id}/recall/${payload.lot_id}`)
                .then(response => {
                    context.commit('SET_LOT', response.data.data)
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    remindMeToBid (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/live2/auction/${payload.auction_id}/remind/${payload.lot_id}`)
                .then(response => {
                    context.commit('SET_LOT', response.data.data)
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    sendAbsenteeBid (context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/live2/auction/${payload.auction_id}/absentee/${payload.lot_id}`, { amount: payload.amount })
                .then(response => {
                    context.commit('SET_LOT', response.data.data)
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    receiveAnnounceLot (context, payload) {
        context.commit('SET_WARN', null)
        context.commit('RESET_BIDS')
        context.commit('RESET_WINNER')
        context.commit('SET_LOT', payload)
        context.commit('SET_CURRENT_LOT', payload)
    },
    receiveResetLot (context, payload) {
        context.commit('SET_WARN', null)
        context.commit('RESET_BIDS')
        context.commit('RESET_WINNER')
        context.commit('SET_LOT', payload)
    },
    receiveOpenBidding (context, payload) {
        context.commit('SET_WARN', null)
        context.commit('RESET_BIDS')
        context.commit('RESET_WINNER')
        context.commit('SET_LOT', payload)
        context.dispatch('openTimer')
    },
    receiveSellLot (context, payload) {
        context.commit('SET_WARN', null)
        context.commit('RESET_BIDS')
        context.commit('RESET_WINNER')
        context.commit('SET_LOT', payload)
    },
    receivePassLot (context, payload) {
        context.commit('SET_WARN', null)
        context.commit('RESET_BIDS')
        context.commit('SET_LOT', payload)
    },
    receiveWinPaddle (context, payload) {
        context.commit('RESET_BIDS')
        context.commit('SET_WIN', payload)
    },
    receivePriceChanged (context, payload) {
        context.commit('RESET_BIDS')
        context.commit('SET_LOT', payload)
    },
    receiveAskChanged (context, payload) {
        context.commit('RESET_BIDS')
        context.commit('SET_LOT', payload)
    },
    receiveWinnerChanged (context, payload) {
        context.commit('RESET_BIDS')
        context.commit('SET_LOT', payload)
    },
    bidReceive (context, payload) {
        context.commit('ADD_BID', payload)
    },
    absenteeReceive (context, payload) {
        context.commit('ADD_BIDS', payload)
    },
    receiveMessage (context, payload) {

    },
    receiveWarn(context, payload) {
        context.commit('SET_WARN', payload)
    },
    receiveRecallLot (context, payload) {
        context.commit('SET_LOT', payload)
    },
    toggleLotsVisibility (context, payload) {
        context.commit('TOGGLE_LOTS')
    },
    addMessage (context, payload) {
        context.commit('ADD_MESSAGE', payload)
    },
    resetMessages (context) {
        context.commit('RESET_MESSAGES')
    },
    openTimer (context) {

        let lot = context.getters.getLot
        let auction = context.getters.getAuction

        if(! lot) {
            return;
        }

        if(lot.c_at) {
            return;
        }

        if(! auction) {
            return;
        }

        if(auction.md != 4 && auction.md != 5) {
            return;
        }

        let ileana = auction.ileana
        if(! ileana) {
            return;
        }
        
        let opened = moment(lot.o_at)
        if(opened.add(ileana.secondsPerLot / 10, 'seconds').isBefore()) {
            return;
        }

        context.commit('SET_TIMER', opened.diff(moment.now(), 'seconds'))

        if(window.interval != undefined) {
            window.clearInterval(window.interval)
        }

        window.interval = window.setInterval(() => {
            context.commit('DECREASE_TIMER')
        }, 1000)
    },
    setTimer(context, timer) {
        context.commit('SET_TIMER', timer)
    }
}
